import axios from "axios";
import { z } from "zod";

export const NEBULA_API_URL_BASE = "https://nebula-api.yay.com:443";
export const NEBULA_API_URL_PREVIEW = "https://preview-nebula-api.yay.com";

export const NEBULA_API_URL_CHAT = "https://nebula-chat.yay.com"

export const CACHE_PRESENCE_ADDR = "nebula_presence_dns";
export const CACHE_CHAT_ADDR = "nebula_chat_dns";

const checkIsPreview = () =>
    window.location.hostname.includes('preview') ||
    window.location.hostname.includes('localhost') ||
    window.location.hostname === 'testing.yay.app';

export const nebulaServerOrDefault = (cacheKey?: string, isChat?: boolean): string => {
    if (!checkIsPreview()) {
        return isChat ? NEBULA_API_URL_CHAT : NEBULA_API_URL_BASE;;
    }

    if (cacheKey) {
        const local = localStorage.getItem(cacheKey);

        if (local) {
            return local;
        }
    }

    return isChat ? NEBULA_API_URL_CHAT : NEBULA_API_URL_BASE;
}

const nebulaUrl = nebulaServerOrDefault();

const LoginResponse = z.object({
    name: z.string(),
    token: z.string(),
    user: z.string(),
});

export type NebulaLoginDetails = z.infer<typeof LoginResponse>;

const NebualApi = {
    login: (username: string, password: string) => new Promise<NebulaLoginDetails>((resolve, reject) => {
        axios.post<unknown>(`${nebulaUrl}/v1/auth/login`, { username, password })
            .then((r) => {
                const details = LoginResponse.safeParse(r.data);

                if (details.error) {
                    reject(details.error);
                } else {
                    resolve(details.data);
                }
            })
            .catch(e => {
                console.error("Failed login", e);
                reject(e)
            })
    })

}

export default NebualApi;
